module.exports = flarum.core.compat['common/utils/throttleDebounce'];